// src/services/authService.js
import axios from "axios";
import { Auth } from "../services/authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export function obtenerTiposDeTramite() {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/tramite`;
  console.log(url);
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export function crearTipoDeTramite(payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/tramite`;
  return axios.post(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function actualizarTipoDeTramite(idOficina, payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/tramite/${idOficina}`;
  return axios.put(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function eliminarTipoDeTramite(idOficina) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/tramite/${idOficina}`;
  return axios.delete(url, {
    headers: {
      Authorization: token,
    },
  });
}
